import { UserProcessStatus } from '@interfaces';
import { UserProcessStatus_POST } from './user-process.POST.status';
import { UserProcessStatus_MOS } from './user-process.MOS.status';

export enum UserProcessMode {
  /**
   * Normal mode with visit in the voivo office
   * - Requires submision of application in the MOS SYSTEM
   * - @todo define behaviour and requirements.
   */
  MOS = 'MOS',

  /**
   * Mode in which application submition is sent by post BUT foreigner has to visit office for fingerprints submition
   * In this mode foreigner might send the documents to the company office via post OR come to the company office to sign the required documents personally
   */
  POST = 'POST',
}

export enum DocumentsSigningMode {
  /**
   * Foreigner will come to the company office to sign the documents.
   * He must provide date when he plans to come to the company office
   */
  PERSONALLY_IN_OFFICE = 'PERSONALLY_IN_OFFICE',

  /**
   * Foreigner will send signed documents by post to the Warsaw office
   */
  SENDING_BY_POST = 'SENDING_BY_POST',
}

export const disabledStatusesWhenMode = {
  [UserProcessMode.MOS]: Object.values(UserProcessStatus_POST),
  [UserProcessMode.POST]: Object.values(UserProcessStatus_MOS),
};
